// src/components/ViewModal.js
import React from 'react';

const ViewModal = ({ invoice, onClose }) => {
  const formatPrice = (price) => price.toLocaleString('fa-IR');

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content view-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>
            <span className="header-icon">📄</span>
            مشاهده فاکتور خرید
          </h3>
          <button className="close-modal" onClick={onClose}>✖</button>
        </div>

        <div className="modal-body">
          {/* اطلاعات اصلی فاکتور به صورت کارت */}
          <div className="invoice-summary-card">
            <div className="summary-row">
              <div className="summary-item">
                <span className="item-label">🏷️ شماره فاکتور:</span>
                <span className="item-value">{invoice.invoiceNumber}</span>
              </div>
              <div className="summary-item">
                <span className="item-label">📅 تاریخ:</span>
                <span className="item-value">{invoice.date}</span>
              </div>
            </div>
            <div className="summary-row">
              <div className="summary-item">
                <span className="item-label">🏢 تامین‌کننده:</span>
                <span className="item-value">{invoice.supplier}</span>
              </div>
              <div className="summary-item total-amount">
                <span className="item-label">💰 مبلغ کل:</span>
                <span className="item-value">{formatPrice(invoice.totalAmount)} تومان</span>
              </div>
            </div>
          </div>

          {/* بخش آیتم‌های فاکتور */}
          <div className="items-section">
            <h4>
              <span className="section-icon">📦</span>
              لیست کالاها
            </h4>
            <div className="items-table-container">
              <table className="items-table-view">
                <thead>
                  <tr>
                    <th>ردیف</th>
                    <th>نام کالا</th>
                    <th>تعداد</th>
                    <th>قیمت واحد</th>
                    <th>جمع</th>
                  </tr>
                </thead>
                <tbody>
                  {invoice.items.map((item, idx) => (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{item.product}</td>
                      <td>{item.quantity}</td>
                      <td>{formatPrice(item.unitPrice)}</td>
                      <td className="total-cell">{formatPrice(item.total)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan="4" className="footer-label">جمع کل:</td>
                    <td className="footer-total">{formatPrice(invoice.totalAmount)} تومان</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="close-btn" onClick={onClose}>بستن</button>
        </div>
      </div>
    </div>
  );
};

export default ViewModal;